(function () {
  function initLightbox() {
    var overlay = document.querySelector('.portfolio-lightbox');
    if (!overlay) return;

    /* Reparent to <body>: this theme applies a transform to a page-level
       wrapper for transitions, which makes position:fixed compute relative
       to that wrapper instead of the real viewport. Moving the overlay to
       be a direct child of body escapes that transformed ancestor. */
    document.body.appendChild(overlay);

    var imgEl = overlay.querySelector('.portfolio-lightbox__image');
    var labelEl = overlay.querySelector('.portfolio-lightbox__label');
    var closeBtn = overlay.querySelector('.portfolio-lightbox__close');
    var prevBtn = overlay.querySelector('.portfolio-lightbox__prev');
    var nextBtn = overlay.querySelector('.portfolio-lightbox__next');

    var currentItems = [];
    var currentIndex = 0;
    var triggerEl = null;

    /* Every frame is a plain <div> in the markup (repeated ~90x across two
       grids), so accessibility is wired up here at runtime instead of
       editing every instance in the template. */
    var allFrames = Array.prototype.slice.call(document.querySelectorAll('.portfolio-item__frame'));
    allFrames.forEach(function (frame) {
      if (frame.hasAttribute('tabindex')) return;
      frame.setAttribute('role', 'button');
      frame.setAttribute('tabindex', '0');
      var labelNode = frame.parentElement.querySelector('.portfolio-item__label');
      if (labelNode) frame.setAttribute('aria-label', 'View larger image: ' + labelNode.textContent);
    });

    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Image preview');

    function show(index) {
      if (!currentItems.length) return;
      currentIndex = (index + currentItems.length) % currentItems.length;
      var item = currentItems[currentIndex];
      var fullSrc = item.img.getAttribute('data-full-src') || item.img.currentSrc || item.img.src;
      imgEl.src = fullSrc;
      imgEl.alt = item.img.alt || '';
      labelEl.textContent = item.label || '';
    }

    function open(items, startIndex, opener) {
      currentItems = items;
      triggerEl = opener || document.activeElement;
      show(startIndex);
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      imgEl.src = '';
      if (triggerEl && typeof triggerEl.focus === 'function') triggerEl.focus();
      triggerEl = null;
    }

    function openFromFrame(frame) {
      var grid = frame.closest('.portfolio-grid');
      if (!grid) return;

      var frames = Array.prototype.slice.call(grid.querySelectorAll('.portfolio-item__frame'));
      var items = frames.map(function (f) {
        var img = f.querySelector('img');
        var labelNode = f.parentElement.querySelector('.portfolio-item__label');
        return { img: img, label: labelNode ? labelNode.textContent : '' };
      });
      var startIndex = frames.indexOf(frame);
      open(items, startIndex, frame);
    }

    document.addEventListener('click', function (e) {
      var frame = e.target.closest('.portfolio-item__frame');
      if (!frame) return;
      openFromFrame(frame);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var frame = e.target.closest('.portfolio-item__frame');
      if (!frame) return;
      e.preventDefault();
      openFromFrame(frame);
    });

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { show(currentIndex - 1); });
    nextBtn.addEventListener('click', function () { show(currentIndex + 1); });

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(currentIndex - 1);
      if (e.key === 'ArrowRight') show(currentIndex + 1);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();
